import moment, { Moment, unitOfTime } from 'moment-timezone'

moment.locale('ru')


const DATE_FORMAT = 'DD.MM.YYYY HH:mm'

export const dateFromFormatter = (date?: string | Moment, fromFormat = DATE_FORMAT) => (
  date && moment(date, fromFormat)
)

export const dateFormatter = (
  date?: string | Moment,
  format: string | [string, string] = DATE_FORMAT,
  defaultData?: string,
) => {
  if (!date) return defaultData

  if (typeof format === 'string') {
    // TODO: Вот эта штука будет бросать время у тех, кто не в МСК.
    // Надо подумать - менять логику тут, или создать новый форматтер и использовать там где нужно.
    return moment(date).tz('Europe/Moscow').format(format)
  }

  return moment(date, format[0]).tz('Europe/Moscow').format(format[1])
}

export const dateFormatterIgnoreTz = (
  date?: string,
  format: string | [string, string] = DATE_FORMAT,
  defaultData?: string,
) => {
  if (!date) return defaultData

  let val = date
  if (/\+\d{2}:\d{2}$/.test(date)) {
    val = date.substring(0, date.length - 6)
  }
  // TODO: это временное решение. по-хорошему надо наверное переписать BTextFieldDate
  // https://track.rstm.pw/browse/MOLK-166
  if (/\d{1,2}\.\d{1,2}\.\d{4}/.test(val)) {
    val = val.split('.').reverse().join('-')
  }

  if (typeof format === 'string') {
    return moment(val).local().format(format)
  }

  return moment(val, format[0]).local().format(format[1])
}

export const uiDateFormatter = (
  date?: string | Moment,
  format: string | [string, string] = DATE_FORMAT,
  defaultData?: string,
) => {
  const formattedDate = dateFormatter(date, format, defaultData)
  if (!formattedDate) return defaultData

  return formattedDate.endsWith('00:00') ? formattedDate.slice(0, formattedDate.length - 8) : formattedDate
}

export const dateIsValid = (date?: string, format = DATE_FORMAT) => (
  date ? moment(date, format).isValid() : false
)

export const toLocalTimezone = (date: string | Moment): Moment => {
  const value = moment.tz(date, 'UTC').local()
  return value
}

export const getLastActiveAt = (date: string, count?: number): string => {
  if (!date) return date
  const result = toLocalTimezone(date)
    // @ts-ignore TODO:
    .preciseDiffLocal(moment(), { seconds: false, count })

  return result || 'Недавно'
}

export const isToday = (date: string | Moment) => {
  if (!date) return false
  return moment(0, 'HH').diff(date, 'days') === 0
}

export const isBeforeToday = (date: string | Moment, user_timezone_diff?: number) => (
  user_timezone_diff ? moment(date).subtract(user_timezone_diff, 'hours').isBefore() : moment(date).isBefore()
)

export const isAfterToday = (date: string | Moment, user_timezone_diff?: number) => (
  user_timezone_diff ? moment(date).subtract(user_timezone_diff, 'hours').isAfter() : moment(date).isAfter()
)

export function getRangeDates(
  startDate: string,
  endDate: string,
  type: unitOfTime.Base,
) {
  const from = moment(startDate)
  const to = moment(endDate)
  const diff = to.diff(from, type)

  const list = []

  for (let i = 0; i < diff; i += 1) {
    const date = moment(startDate).add(i, type)
    list.push(date)
  }
  return list
}

export function getRangeDatesUntil(
  startDate: string,
  endDate: string,
  type: unitOfTime.Base,
) {
  const from = moment(startDate)
  const to = moment(endDate).add(1, 'days')
  const diff = to.diff(from, type)

  const list = []

  for (let i = 0; i < diff; i += 1) {
    const date = moment(startDate).add(i, type)
    list.push(date)
  }
  return list
}
